import { useState } from 'react';

// component
import {
    setNavigation,
    createHomeProp,
    createSearchProp,
    createExploreProp,
    createTrendingProp,
    createMessageProp,
    createProfileProp,
    createSettingProp,
} from '../';

// mui
import { Container, Box, Stack, Grid, IconButton, Typography, Tooltip } from '@mui/material';

import { alpha, useTheme } from '@mui/material/styles';

// icons
import {
    Home as HomeIcon,
    HomeOutlined as HomeOutlinedIcon,
    Recommend as RecommendIcon,
    RecommendOutlined as RecommendOutlinedIcon,
    Settings as SettingsIcon,
    SettingsOutlined as SettingsOutlinedIcon,
    Search as SearchIcon,
    SearchOutlined as SearchOutlinedIcon,
    Explore as ExploreIcon,
    ExploreOutlined as ExploreOutlinedIcon,
    Person as PersonIcon,
    PersonOutlined as PersonOutlinedIcon,
    Message as MessageIcon,
    MessageOutlined as MessageOutlinedIcon,
    TrendingUp as TrendingUpIcon,
    TrendingUpOutlined as TrendingUpOutlinedIcon,
} from '@mui/icons-material';

// client-shared
import { storage } from '@goldblack/client-storage';
import { display } from '@goldblack/client-utils';

function TopContent(props) {
    const userSession = storage.transience.getValue('user');
    const [value, setValue] = useState(props.path === 'home' ? 'recommend' : (props.path ?? 'recommend'));
    const [showTooltips, setShowTooltips] = useState([false, false, false, false, false, false, false]);
    const theme = useTheme();

    const openHomeMenu = (event) => {
        setNavigation(createHomeProp());
        setValue('recommend');
        setShowTooltip(0, false);
    };

    const openSearchMenu = () => {
        setNavigation(createSearchProp());
        setValue('search');
        setShowTooltip(1, false);
    };

    const openExploreMenu = () => {
        setNavigation(createExploreProp());
        setValue('explore');
        setShowTooltip(2, false);
    };

    const openTrendingMenu = () => {
        setNavigation(createTrendingProp());
        setValue('trending');
        setShowTooltip(3, false);
    };

    const openMessageMenu = (event) => {
        setNavigation(createMessageProp());
        setValue('messages');
        setShowTooltip(4, false);
    };

    const openProfileMenu = () => {
        setNavigation(createProfileProp(userSession));
        setValue('profile');
        setShowTooltip(5, false);
    };

    const openSettingMenu = (event) => {
        setNavigation(createSettingProp());
        setValue('settings');
        setShowTooltip(6, false);
    };

    const setShowTooltip = (index, value) => {
        setShowTooltips((prevState) => [...prevState.slice(0, index), value, ...prevState.slice(index + 1)]);
    };

    const MyButton = (index, title, tooltip, iconFilled, iconOutlined, onClick) => {
        const isSelected = value === title;
        return (
            <Tooltip
                key={index}
                title={tooltip}
                open={showTooltips[index]}
                disableHoverListener
                onMouseEnter={() => setShowTooltip(index, true)}
                onMouseLeave={() => setShowTooltip(index, false)}>
                <IconButton
                    onClick={onClick}
                    color='primary'
                    aria-label={tooltip}
                    sx={{
                        backgroundColor: isSelected ? alpha(theme.palette.primary.main, 0.1) : 'transparent',
                        borderRadius: '12px',
                        //transition: 'all 0.3s ease', // 부드러운 전환 효과
                        '&:hover': {
                            backgroundColor: isSelected
                                ? alpha(theme.palette.primary.main, 0.2) // 선택된 상태에서 호버 시 더 진하게
                                : alpha(theme.palette.primary.main, 0.1), // 일반 호버
                        },
                    }}>
                    {value === title ? iconFilled : iconOutlined}
                </IconButton>
            </Tooltip>
        );
    };

    const createButtons = () => {
        let comps = [];
        comps.push(MyButton(0, 'recommend', 'recommend', <RecommendIcon />, <RecommendOutlinedIcon />, openHomeMenu));
        comps.push(MyButton(1, 'search', 'search', <SearchIcon />, <SearchOutlinedIcon />, openSearchMenu));
        comps.push(MyButton(2, 'explore', 'explore', <ExploreIcon />, <ExploreOutlinedIcon />, openExploreMenu));
        comps.push(
            MyButton(3, 'trending', 'trending', <TrendingUpIcon />, <TrendingUpOutlinedIcon />, openTrendingMenu),
        );
        comps.push(MyButton(4, 'messages', 'messages', <MessageIcon />, <MessageOutlinedIcon />, openMessageMenu));
        comps.push(MyButton(5, 'profile', 'profile', <PersonIcon />, <PersonOutlinedIcon />, openProfileMenu));
        comps.push(MyButton(6, 'settings', 'settings', <SettingsIcon />, <SettingsOutlinedIcon />, openSettingMenu));
        return comps;
    };

    return (
        <Grid
            container
            spacing={0}
            direction='row'
            justifyContent='space-evenly'
            alignItems='center'
            sx={{ minHeight: display.formatPxString(props.config.commonTopMinHeight) }}>
            {createButtons()}
        </Grid>
    );
}

export { TopContent };
